.paper {
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  border-radius: var(--tuna-shape-borderRadius);
}

.elevation0 {
  box-shadow: none;
}

.elevation1 {
  box-shadow: var(--tuna-shadow-1);
}

.elevation2 {
  box-shadow: var(--tuna-shadow-2);
}

.elevation3 {
  box-shadow: var(--tuna-shadow-3);
}

.elevation4 {
  box-shadow: var(--tuna-shadow-4);
}

.outlined {
  border: 1px solid var(--tuna-palette-divider);
  box-shadow: none;
}
